<template>
    <div>
        <hr/>
        <h4>Scheduler</h4>
        <div v-if="json && json.schedulers">
            <div class="description">
                You can pick from the following scheduling policies to run the simulation for this tutorial:
            </div>
            <radio v-for="scheduler in json.schedulers" v-model="selected" :selected-value="scheduler" type="success">
                {{ schedulerType[scheduler].name }}
                <div v-if="selected==scheduler" class="description">{{ schedulerType[scheduler].description }}</div>
            </radio>
        </div>
        <div v-if="!json || !json.schedulers" class="description">
            This tutorial does not specify any schedulers; default <strong>round-robin</strong> scheduler will be used.
        </div>
    </div>
</template>

<script>

import SchedulerType from 'runtime/scheduler/types.js';

export default {
  name: 'schedulerPicker',
  props: ["json"],
  data () {
    return {
        selected: null,
        schedulerType: SchedulerType
    }
  },
  mounted() {
      if (this.json && this.json.schedulers) {
        this.selected =  this.json.schedulers[0];
      }
  },
  components: {
  },
  methods: {
      getScheduler() {
          return this.selected ? this.selected : SchedulerType.ROUNDROBIN;
      }
  },
  watch: {
  }
}
</script>

<style scoped>
    .description {
        font-size: small;
        color: silver;
    }
</style>


// WEBPACK FOOTER //
// schedulerPicker.vue?8c1aa176